// Static return destinations for exiting/auto-restoring a preview session,
// keyed by the JWT's `preview_mode` claim ('user' | 'role'). The admin
// always lands back on the settings screen the preview mode is launched
// from, regardless of where they navigated to while previewing.
export const PREVIEW_MODE_ROUTES: Record<string, string> = {
  user: '/settings/user',
  role: '/settings/roles',
};

//All End points
export const APIPaths = {
  wsTicket: '/auth/ws-ticket/',

  // <!---All api enpoints for onboarding.js--->
  getAllCouriers: '/onboarding/couriers/',
  linkCourierAccount: '/auth/link-courier-to-company/',
  products: '/onboarding/products/',
  getAllSensors: '/onboarding/sensors/',
  linkSensorsAccount: '/onboarding/company-sensors/',
  linkSensorsAccountV2: '/onboarding/company-sensors/v2/',
  linkSensorsAccountBulk: '/onboarding/company-sensors/v2/bulk/',
  verifyCompanySensor: '/onboarding/company-sensors/v2/verify/',
  users: '/auth/users/',
  previewUsers: '/auth/users/preview/list/',
  userInviteTemplate: '/auth/users/invite-template/',
  userBulkParse: '/auth/users/bulk-parse/',
  previewExit: '/auth/users/preview/exit/',
  rolesPreview: '/auth/roles/preview/',
  teamUsers: '/auth/teams-users/',
  location: '/onboarding/locations/',
  notifications: '/shipment/alert/',
  product_type: '/onboarding/product-types/',
  create_account: '/onboarding/create-account/',
  contact_sales: '/auth/contact-sale/',
  onboardingGroupedLocations: '/onboarding/locations/v2/grouped/',
  onboardingLocationsParsedList: '/onboarding/locations/v2/parsed-list/',
  // User activity update here START
  userActivityUsersLite: '/user-activity/users/lite/', // new real api endpoint
  userActivityEventTypes: '/user-activity/events/', // new real api endpoint
  userActivityLog: '/user-activity/activity/', // new real api endpoint
  userActivityExport: '/user-activity/activity/export/',

  // User activity update here END

  // Help Center endpoints Start
  help_center: '/help-center/',
  // Help Center endpoints END

  //<!---All api enpoints for settings.js--->
  settingsProfile: '/auth/users/profile/',
  ownershipTransfer: '/auth/transfer-ownership/',
  designations: '/auth/designations/',
  settingsLocation: '/onboarding/locations/v2/',
  transportProvider: '/onboarding/couriers/',
  companyTransportProvider: '/onboarding/couriers/',
  pendingUsers: '/auth/pending-users/',
  resendInvite: '/auth/users/resend-invite/',
  transportProviderDetail: '/auth/company-couriers-details/',
  teamsDDLForFeature: '/auth/feature-teams/',
  aiToggle: '/auth/company-ai-enable/',
  aiSettings: '/auth/ai-settings/',
  aiTransferNumber: '/auth/ai-transfer-number/',
  alertThreshold: '/shipment/alert-threshold/',
  simulatorAlertThresholds: '/shipment/simulator-alert-thresholds/',
  alertCustomization: '/shipment/alert-configurations/',
  companyInfo: '/auth/company-info/',
  companyPhoneNumbers: '/auth/company-phone-numbers/',
  service_level_transport_provider: '/auth/carriers-service-levels/',
  courierReorder: '/auth/company-couriers-contacts/reorder/',
  contactsDirectory: '/auth/general-support-directory/',
  addDirectory: '/auth/company-couriers-contacts/add-directory/',
  courierChangelog: '/auth/company-couriers-contacts/changelog/',
  locationTypes: '/onboarding/location-types/',
  customerCredentials: '/customer-credentials/',
  laneVendorConnections: '/shipment/v1/lane-planner/vendor-connections/',
  laneConfig: '/shipment/v1/lane-planner/config/',
  lanePlaces: '/shipment/v1/lane-planner/places/',
  lanePlacesResolve: '/shipment/v1/lane-planner/places/resolve/',
  lanePlacesSites: '/shipment/v1/lane-planner/places/sites/',
  laneSearches: '/shipment/v1/lane-planner/searches/',
  laneSavedSearches: '/shipment/v1/lane-planner/saved-searches/',
  laneSavedQuotes: '/shipment/v1/lane-planner/saved-quotes/',
  laneBookings: '/shipment/v1/lane-planner/bookings/',
  freightMarkupRates: '/auth/freight-markup-rates/',
  freightMarkupRatesOptions: '/auth/freight-markup-rates/options/',

  //<!------All api enpoints for shipment.ts----> [//added by nisha]
  addNewShipment: '/shipment/track/',
  addShipmentNotification: '/shipment/notifications/',
  settingsCourier: '/auth/company-couriers/',
  courierContacts: '/auth/couriers-contacts/',
  uploadBulkShipment: '/shipment/upload-shipments/',
  uploadFile: '/shipment/file-upload/',
  downloadBulkUploadTemplate: '/shipment/download-shipments_template/',
  callTranscript: '/shipment/alert-call-transcript/',
  callTranscriptCompanyAlert: '/shipment/company-alert-call-transcript/',
  emailTranscript: '/shipment/alert-email-transcript/',
  callTranscriptOneTime: '/shipment/one-time-notification-call-transcript/',
  emailTranscriptOneTime: '/shipment/one-time-notification-email-transcript/',
  oneTimeResolve: '/shipment/one-time-notification-event-resolve/',
  oneTimeDismiss: '/shipment/one-time-notification-event-dismiss/',
  shipmentAlertStatus: '/shipment/shipment-alert-ai-status/',
  terminateAiEmail: '/shipment/terminate-ai-email/',
  alertEmailReplies: '/shipment/alerts/',
  oneTimeEmailReplies: '/shipment/one-time-notifications/',
  shipmentNotificationListing: '/shipment/notifications/',
  notificationRecipient: '/auth/teams-users/',
  bulkUpload: '/shipment/bulk-upload-files/v2/',
  bulkValidate: '/shipment/bulk-validate/v2/',
  bulkCreate: '/shipment/bulk-create/v2/',
  setExternalAlert: '/shipment/share-shipment-alerts/',
  updateDeliveryAddressTL: '/shipment/share-shipment-issues/',
  alertRecipient: '/shipment/alert-recipients/',
  replyComment: '/shipment/coc-messaging/',
  muteNotificationForYourself: '/shipment/mute-notifications/',
  shipmentStatus: '/shipment/status/',
  shipmentTeams: '/shipment/shipment-with-teams/',
  checkMentionsUsers: '/shipment/user-team-check-api/users/',
  shipmentProducts: '/shipment/products/',
  executionLegProducts: '/shipment/execution-legs/products/',
  shipmentLegs: '/shipment/legs/list/',
  shipmentBookings: '/shipment/bookings/',
  worldCourierBookings: '/shipment/world-courier-bookings/',
  worldCourierBookingProjectOptions:
    '/shipment/world-courier-bookings/project-options/',
  worldCourierBookingTemplates: '/shipment/world-courier-booking-templates/',
  cryoportBookings: '/shipment/cryoport-bookings/',
  cryoportLocationTemplates: '/shipment/cryoport-location-templates/',
  shipmentBookingTemplates: '/shipment/booking-templates/',
  shipmentBookingQuickstatCompanyProfile:
    '/shipment/bookings/quickstat-company-profile/',
  reorderPinTabs: '/shipment/tabs/reorder/',
  fedexQuote: '/shipment/fedex/quote/',
  fedexShip: '/shipment/fedex/ship/',
  fedexHealth: '/shipment/fedex/health/',
  fedexAccounts: '/shipment/fedex/accounts/',
  fedexEmailLabel: '/shipment/fedex/email-label/',
  fedexPickupPrefill: (shipmentId: string) =>
    `/shipment/fedex/pickup/prefill/${shipmentId}/`,
  fedexPickupAvailability: '/shipment/fedex/pickup/availability/',
  fedexPickup: '/shipment/fedex/pickup/',
  fedexPickupCancel: '/shipment/fedex/pickup/cancel/',
  upsQuote: '/shipment/ups/quote/',
  upsShip: '/shipment/ups/ship/',
  upsHealth: '/shipment/ups/health/',
  upsAccounts: '/shipment/ups/accounts/',
  upsEmailLabel: '/shipment/ups/email-label/',
  specialtyProviders: '/shipment/specialty/providers/',
  specialtyOptions: '/shipment/specialty/options/',
  specialtyHealth: '/shipment/specialty/health/',
  specialtyBook: '/shipment/specialty/book/',
  shipmentReferenceNumberSuggest: '/shipment/reference-number/suggest/',
  shipmentReferenceLookup: '/shipment/reference-number/lookup/',
  shipmentPromote: '/shipment/', // append `${id}/promote/`
  shipmentReassignCarrier: '/shipment/', // append `${id}/reassign-carrier/`
  external_link_report_issues: '/shipment/share-shipment-issues/',

  //<!---All api enpoints for shipments.js--->
  authenticate_password: '/shipment/authenticate-shipment/',
  share_shipment: '/shipment/share-shipment/',
  shipments: '/shipment/',
  post_shipments: '/shipment/v2/',
  post_shipments_v3: '/shipment/v3/',
  customer_leg_execution_legs: '/shipment/customer-leg/execution-legs/',
  execution_legs: '/shipment/execution-legs/',
  execution_leg_detail: (id: string) => `/shipment/execution-legs/${id}/`,
  shipment_viewer: '/shipment/shipment-viewers/',
  geoFenceStops: (id: string) => `/shipment/${id}/geo-fences/stops/`,
  shipmentGeoFence: (shipmentId: string, stopKey: string) =>
    `/shipment/${shipmentId}/geo-fences/${encodeURIComponent(stopKey)}/`,
  routeDeviationCandidates: (id: string) =>
    `/shipment/${id}/route-deviation/candidates/`,
  // The whole-shipment setting; the server accepts no other leg key yet.
  routeDeviationSetting: (id: string) =>
    `/shipment/${id}/route-deviation/shipment/`,
  custody_comments: '/shipment/chain-of-custody/comments/',
  markShipmentCocCommentsRead: (shipmentId: string) =>
    `/shipment/${shipmentId}/coc-comments/mark-read/`,
  shipment_alert: '/shipment/shipment-alerts/',
  alertAssignment: (alertId: string) =>
    `/shipment/shipment-alerts/${alertId}/assignment/`,
  alertOwnerOptions: (shipmentId: string) =>
    `/shipment/shipments/${shipmentId}/alert-owner-options/`,
  shipmentAlertActivity: (shipmentId: string) =>
    `/shipment/shipments/${shipmentId}/alert-activity/`,
  shipmentAlertActivitySeen: (shipmentId: string) =>
    `/shipment/shipments/${shipmentId}/alert-activity/seen/`,
  resloved_alert: '/shipment/shipment-alert-resolved/',
  resloved_alert_comment: '/shipment/shipment-alert-complete/',
  shipment_archive: '/shipment/shipment-archive/',
  shipment_mark_as_delivered: '/shipment/shipment-delivered/',
  initiateAiCall: '/intervention/call/initiate/',
  noMessage: '/auth/ai-static-message/',
  get_link_code: '/shipment/link-codes/',
  get_rtg_codes: '/shipment/rtg-codes/',
  retry_call: '/shipment/one-time-notifications/',
  alert_retry_call: '/shipment/alert-ai-comment-retry/',
  coc_download: '/shipment/coc-download/',
  post_shipments_calendar: '/shipment/calendar/',
  more_shipments_calendar: '/shipment/calendar/drill-down/',
  shipment_headers: '/shipment/v3/columns/',

  //<!---All api enpoints for home.js--->
  shipment_locations: '/shipment/shipment-locations/',
  button_status: '/auth/button-status/',
  shipment_chart: '/auth/shipment-chart/',
  cycle_time_chart: '/auth/cycle-time-chart/',
  ontime_chart: '/auth/shipment-chart-ontime/',
  ontime_pickup_chart: '/auth/time-pickup-chart/',
  schedule_adherence_chart: '/auth/schedule-adherence-chart/',
  average_chart: '/auth/shipment-chart-transit/',
  dwell_Time_chart: '/auth/dwell-time-chart/',
  dwell_time_locations: '/auth/dwell-time-locations/',
  right_Time_chart: '/auth/alerts-deep-dive/',
  alert_workload_by_owner_chart: '/auth/home-kpi-alert-workload-by-owner/',
  alert_time_to_action_chart: '/auth/home-kpi-alert-time-to-action/',
  alert_outcomes_chart: '/auth/home-kpi-alert-outcomes/',
  delivery_exception_chart: '/auth/delivery-exceptions-deep-dive/',
  invoice_disputes_chart: '/auth/invoice-disputes-deep-dive/',
  cost_chart: '/auth/cost-deep-dive/',
  freight_markup_chart: '/auth/freight-markup-deep-dive/',
  sku_volume_chart: '/auth/sku-volume-chart/',
  sku_volume_trend: '/auth/sku-volume-trend/',
  home_map_filter: '/shipment/shipment-locations/',
  home_news_flash: '/auth/newsflash/',
  monitor_arrivals: '/shipment/monitor/arrivals/',
  monitor_trip: '/shipment/monitor/trip/',
  home_target_metrics: '/auth/company-target/',
  on_time_settings: '/auth/shipment-chart-ontime/',
  chart_click_data: '/auth/drill-down/',
  download_report_shipments: '/shipment/raw-data-report/',
  download_report: '/shipment/raw-report/',
  download_report_shipments_modal: '/shipment/report-download/',
  download_raw_data: '/shipment/shipment-report/',
  preset_report_filters: '/shipment/report-filters/',
  preset_report_filters_tabs: '/shipment/report-presets/',
  shipment_report_filters: '/shipment/report-filters/',
  download_chart_modal: '/auth/download-drill-down/',
  //ZD-2579:per-user KPI filter persistence
  home_kpi_filters: '/auth/home-kpi-filters/',
  home_kpi_filter_visibility: '/auth/home-kpi-filter-visibility/',
  home_map_filters: '/auth/home-map-filters/',
  home_kpi_tabs: '/auth/home-kpi-tabs/',
  home_kpi_tabs_reorder: '/auth/home-kpi-tabs/reorder/',
  home_kpi_widgets: '/auth/home-kpi-widgets/',
  home_kpi_tab_layout: (tabId: string) =>
    `/auth/home-kpi-tabs/${tabId}/layout/`,
  home_kpi_tab_filters: (tabId: string) =>
    `/auth/home-kpi-tabs/${tabId}/filters/`,
  // used by the legacy Home tree only
  save_edit_charts: '/auth/home-kpi-layout/',
  home_reports_layout: '/auth/home-reports/layout/',
  home_reports_sections_data: '/auth/home-reports/sections/data/',
  home_reports_operational_drivers_summary:
    '/auth/home-reports/operational-drivers/summary/',
  home_reports_volume_breakdown_summary:
    '/auth/home-reports/volume-breakdown/summary/',
  home_reports_cost_breakdown_summary:
    '/auth/home-reports/cost-breakdown/summary/',
  home_reports_drilldown: '/auth/home-reports/drilldown/',
  home_reports_drilldown_download: '/auth/home-reports/drilldown/download/',
  home_reports_sections_download: '/auth/home-reports/sections/download/',

  // KPI side panel endpoints
  otd_delay_reasons: '/auth/otd-delay-reasons/',
  alerts_insights: '/auth/alerts-insights/',

  // New pre-calculated report endpoints
  pre_calculated_report: '/shipment/pre-calculated-report/',
  report_recalculate: '/shipment/report-recalculate/',
  report_task_status: '/shipment/report-task-status/',
  report_download_csv: '/shipment/report-download/',
  shipment_report_schedules: '/shipment/report-schedules/',
  report_tabs: '/shipment/report-tabs/',

  //<!---All api enpoints for chatbot.js--->
  conversations: '/auth/conversation/all/',
  user_conversation: '/auth/conversation/',

  //<!--- All api enpoints for ROLES AND PERMISSIONS --->
  add_role: '/auth/roles/',
  role: '/auth/roles/',
  role_permissions: '/auth/roles/permissions/',
  clear_cache: '/shipment/clear-cache/',
  permission_options: '/auth/roles/permission-options/',
  refresh_token: '/auth/refresh-token/',
  get_menu: '/auth/user-menu-permissions/',
  home_permissions: '/auth/home-kpi-charts/',
  home_companion_shipments_tabs: '/shipment/tabs/',

  //<!---All api enpoints for teams.js--->
  teams: '/auth/teams/',
  team_connect_webhook: '/auth/teams/connect-webhook/',

  //<!---All api enpoints for airports--->
  airport_contacts: '/airport/contacts/',
  airport_data: '/shipment/airports/',
  customs_offices: '/shipment/customs-office/',
  customs_office_port_code: '/shipment/customs-office-firms/',
  airport_details: '/airport/airline/details/',

  //<!---All api enpoints for toolbar notifications--->
  listRecipients: '/shipment/alert-recipients/',
  createToolbarNotificaitons: '/shipment/notifications/',
  all_airport_data: '/shipment/airports-info/',
  airport_delay: '/shipment/airports-delay-stats/',
  airport_delay_history: '/shipment/airport-delay-history/',
  airport_delay_history_bulk: '/shipment/airport-delay-history-bulk/',

  //<!---All api enpoints for airport module--->
  airport_list: '/airport/',

  //<!-- API endpoints for route prediction -->
  get_route_prediction: '/shipment/route-prediction',
  mass_actions: '/shipment/mass-actions/',
  one_time: '/shipment/one-time-notifications/',

  // Logiblocks endpoints
  listWorkflows: '/logiblocks/list_workflows/',
  getWorkflow: '/logiblocks/get_workflow/',
  getWorkflowVersion: '/logiblocks/get_workflow_version/',
  getTestRunWorkflow: '/logiblocks/get_test_run_workflow/',
  startTestRun: '/logiblocks/start_test_run/',
  getTestShipmentCandidates: '/logiblocks/get_test_shipment_candidates/',
  createDraftWorkflow: '/logiblocks/create_draft_workflow/',
  duplicateWorkflow: '/logiblocks/duplicate_workflow/',
  updateWorkflow: '/logiblocks/update_workflow/',
  publishWorkflow: '/logiblocks/publish_workflow/',
  unpublishWorkflow: '/logiblocks/unpublish_workflow/',
  deleteWorkflow: '/logiblocks/delete_workflow/',
  listWorkflowHistory: '/logiblocks/list_workflow_history/',
  getWorkflowHistory: '/logiblocks/get_workflow_history/',
  listWorkflowPublishEvents: '/logiblocks/list_workflow_publish_events/',
  listTemplates: '/logiblocks/list_templates/',
  getTemplate: '/logiblocks/get_template/',
  getWorkflowNodeDropdownLabels:
    '/logiblocks/get_workflow_node_dropdown_labels/',
  workflowStats: '/logiblocks/stats/',
  filterControlFlowFields: '/logiblocks/get_filter_control_flow_fields/',
  variableValueOptions: '/logiblocks/get_variable_value_options/',
  listSystemDatePresets: '/logiblocks/list_system_date_presets/',
  listAlertTags: '/logiblocks/list_alert_tags/',
  listSavedDateLists: '/logiblocks/list_saved_date_lists/',
  createSavedDateList: '/logiblocks/create_saved_date_list/',
  getSavedDateList: '/logiblocks/get_saved_date_list/',
  updateSavedDateList: '/logiblocks/update_saved_date_list/',
  deleteSavedDateList: '/logiblocks/delete_saved_date_list/',

  // Logiblocks AI Builder endpoints
  logiblocksAgentStart: '/logiblocks-agent/start/',
  logiblocksAgentChat: '/logiblocks-agent/chat/',
  logiblocksAgentChatStream: '/logiblocks-agent/chat_stream/',
  logiblocksAgentValidateGraph: '/logiblocks-agent/validate_graph/',
  logiblocksAgentSessions: '/logiblocks-agent/sessions/',

  //<!-- api enpoints for AI history -->
  ai_history: '/shipment/ai-history/',
  ai_history_mass_actions: '/shipment/ai-history/completion/',
  ai_history_counts: '/shipment/ai-history/ai-states/',

  //<!-- api enpoints for AI chat drawer -->
  aiInsightsChatbotSessions: '/ai-insights-chatbot/sessions/',
  aiInsightsChatbotStart: '/ai-insights-chatbot/start/',
  aiInsightsChatbotSession: '/ai-insights-chatbot/session/',
  aiInsightsChatbotChat: '/ai-insights-chatbot/chat/',
  aiInsightsChatbotFeedback: '/ai-insights-chatbot/feedback/',
  aiInsightsChatbotSavedQuestions: '/ai-insights-chatbot/saved-questions/',

  //<!-- api endpoints for the new Bedrock AgentCore chat agent (prototype) -->
  agentCoreChatStart: '/agentcore-chat/start/',
  agentCoreChatChat: '/agentcore-chat/chat/',
  agentCoreChatDrilldown: '/agentcore-chat/chat/drilldown/',
  agentCoreChatSessions: '/agentcore-chat/sessions/',
  agentCoreChatSession: '/agentcore-chat/session/',
  agentCoreChatFeedback: '/agentcore-chat/feedback/',

  //<!-- api enpoints for AI agents -->
  ai_agents_list: '/ai-agent/',
  ai_agent_voice: '/ai-agent/voice/',
  ai_agent_dropdowns: '/ai-agent/dropdowns/',
  ai_agent_dynamicVars: '/ai-agent/dynamic-variables/',
  ai_agent_template: '/ai-agent/template/',
  ai_agent_test: '/ai-agent/test/',
  ai_agent_test_email: '/ai-agent/test-email/',
  ai_agent_test_result: '/shipment/webhooks/custom-agent-call/',
  ai_agent_improve_prompt: '/ai-agent/improve-prompt/',
  ai_agent_validate_prompt: '/ai-agent/validate-prompt/',
  ai_agent_improve_resolution_prompt: '/ai-agent/improve-resolution-prompt/',
  ai_agent_custom_collect: '/ai-agent/collect/custom/',

  //<!-- api enpoints for inventory -->
  inventory: '/onboarding/inventory/records/',
  inventory_refresh: '/onboarding/inventory/refresh/',
  inventory_refresh_status: '/onboarding/inventory/refresh-status/',
  inventoryv2: '/onboarding/inventory/notifications/list/',
  products_v2: '/onboarding/products/v2/',

  //<!-- api enpoints for GxP Temperature -->
  gxp_settings: '/gxp/settings/',
  gxp_products: '/gxp/products/',
  gxp_reports_list: '/gxp/reports/list/',
  gxp_resports: '/gxp/reports/',

  //<!-- api endpoints for useractivity.js -->
  activityBeacon: '/user-activity/activity/beacon/',
};

// AI Email Timeout Configuration
// Timeout duration in minutes for AI email processing
export const AI_EMAIL_TIMEOUT_MINUTES = 60;

/** Cencora Prod — company-specific UI restrictions. */
export const CENCORA_PROD_COMPANY_ID = '33a124fb-cd79-454a-9dee-05fdb8f75391';

/** Cencora Sandbox — must not inherit Prod-only UI hides. */
export const CENCORA_SANDBOX_COMPANY_ID =
  '5a808f5b-5227-487e-aa95-fe0daa04cfd8';

/** Companies where Control Tower hides the "+ New shipment" button. */
export const HIDE_NEW_SHIPMENT_BUTTON_COMPANY_IDS = new Set<string>([
  CENCORA_PROD_COMPANY_ID,
]);

export function hideNewShipmentButtonForCompany(
  companyId: string | undefined | null
): boolean {
  if (!companyId) return false;
  return HIDE_NEW_SHIPMENT_BUTTON_COMPANY_IDS.has(companyId);
}

/** Companies where the product form hides "Use FDA database". */
export const HIDE_FDA_DATABASE_COMPANY_IDS = new Set<string>([
  CENCORA_PROD_COMPANY_ID,
]);

export function hideFdaDatabaseForCompany(
  companyId: string | undefined | null
): boolean {
  if (!companyId) return false;
  return HIDE_FDA_DATABASE_COMPANY_IDS.has(companyId);
}

/** FS2 pilot (UAT / rob+25 demo company). */
export const FS2_PILOT_COMPANY_ID = 'fa0e11b7-8eda-41a5-94ca-4a59515b9388';

/** FS2 production company (UAT and prod use different UUIDs). */
export const FS2_PROD_COMPANY_ID = 'f489e4e3-d8be-4036-9f93-5361405ef1d1';

/** Companies that see the Lane planner (cargo.one Ocean/Air) entry under
 *  the New shipment menu. Keep in sync with the default
 *  settings.CARGO_ONE_ALLOWED_COMPANY_IDS (FS2 UAT + FS2 prod).
 *  Deployments may narrow the server allowlist via env; the proxy still
 *  returns 403 for anyone not listed there. */
export const LANE_PLANNER_COMPANY_IDS = new Set<string>([
  FS2_PILOT_COMPANY_ID,
  FS2_PROD_COMPANY_ID,
]);

export function lanePlannerEnabledForCompany(
  companyId: string | undefined | null
): boolean {
  if (!companyId) return false;
  return LANE_PLANNER_COMPANY_IDS.has(companyId.toLowerCase());
}
